import React, { useEffect, useState } from "react";

import Tab from "react-bootstrap/Tab";
import "./Admin.css";
import { Col, Form, Modal, Row } from "react-bootstrap";
import axios from "axios";
import { useSelector } from "react-redux";
import AdminSideBar from "./AdminSideBar";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
//import supabase from "../supabase-client";

function AdminProductos() {
  /* MODALES */
  //console.log(supabase.auth.session());
  const user = useSelector((state) => state.user_auth);
  const [modalAgregar, setModalAgregar] = useState(false);
  const [modalBorrar, setModalBorrar] = useState(false);
  const [modalEditar, setModalEditar] = useState(false);

  /* USE STATES DE EDITAR MODAL  */
  const [product_id, setProduct_id] = useState("");
  const [nombre, setNombre] = useState("");
  const [categoria, setCategoria] = useState([]);
  const [precio, setPrecio] = useState(0);
  const [stock, setStock] = useState(0);
  const [descripcion, setDescripcion] = useState("");
  const [recomendado, setRecomendado] = useState(false);
  const [destacado, setDestacado] = useState(false);
  const [imagenProducto, setImagenProducto] = useState("");
  const [imagenDestacado, setimagenDestacado] = useState("");
  const [textoDestacado, settextoDestacado] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [recommended, setRecommended] = useState(false);
  const [featured, setFeatured] = useState(false);

  const [contador, setContador] = useState(0);
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  let delayInMilliseconds = 500;

  const deleteProduct = async () => {
    const deleteURL = process.env.REACT_APP_API_URL + `/admin/products/${deleteId}`;
    try {
      const response = await axios({
        method: "DELETE",
        url: deleteURL,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });
      if (response.status === 200) {
        toast.info(`${response.data.message}`, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setDeleteId("");
        setTimeout(function () {
          setContador(contador + 1);
        }, delayInMilliseconds);
      }
    } catch (error) {
      toast.error(`Error : ` + error, {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setTimeout(function () {
        setContador(contador + 1);
      }, delayInMilliseconds);
    }
  };

  const postProduct = async (e) => {
    console.log("ESTE EL EL TOKEN : ", user.token);
    const postURL = process.env.REACT_APP_API_URL + `/admin/products`;
    e.preventDefault();
    try {
      console.log("EVENTO : ", e.target);
      const formData = new FormData(e.target);

      const response = await axios({
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${user.token}`,
        },
        url: postURL,
        data: formData,
      });
      if (response.status === 200) {
        toast.info(`😀 Producto creado correctamente!`, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setModalAgregar(false);
        setTimeout(function () {
          setContador(contador + 1);
        }, delayInMilliseconds);
        //vaciar las variables de estado
      }
    } catch (error) {
      console.log(error);
      toast.error(`Error : ` + error, {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const editProduct = async (e) => {
    const URL = process.env.REACT_APP_API_URL + `/admin/products`;
    e.preventDefault();
    try {
      console.log("EVENTO : ", e.target);
      const formData = new FormData(e.target);
      console.log(formData);

      const response = await axios({
        method: "PATCH",
        url: URL,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${user.token}`,
        },
        data: formData,
      });
      if (response.status === 200) {
        toast.info(`😀 Producto editado correctamente!`, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setTimeout(function () {
          setContador(contador + 1);
        }, delayInMilliseconds);
        setModalEditar(false);
      }
    } catch (error) {
      console.log(error);
      toast.error(`Error : ` + error, {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {
    const productsURL = process.env.REACT_APP_API_URL + `/products`;
    const categoriesURL = process.env.REACT_APP_API_URL + `/categories`;

    const fetchAllProducts = async () => {
      try {
        const productsData = await axios({
          method: "GET",
          url: productsURL,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        });
        setProducts(productsData.data);
      } catch (error) {
        console.log(error);
      }
    };
    const fetchAllCategories = async () => {
      try {
        const categoriesData = await axios({
          method: "GET",
          url: categoriesURL,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        });
        setCategories(categoriesData.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchAllCategories();
    fetchAllProducts();
  }, [contador]);

  return (
    <div id="twc-admin">
      <div className="container">
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <Row className="mt-6 mb-5">
            <Col sm={2} className="d-flex flex-column ">
              <AdminSideBar />
              <button
                type="button"
                className="btn btn-success d-flex justify-content-center align-items-center mt-5"
                onClick={() => setModalAgregar(true)}
              >
                Agregar Producto
              </button>
            </Col>
            <Col sm={10}>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <div className="shadow p-4 border border-dark rounded admin-table">
                    {products.length !== 0 ? (
                      <table className="table table-light table-striped table-hover">
                        <thead>
                          <tr>
                            <th scope="col">ID</th>
                            <th scope="col">Nombre</th>
                            <th scope="col">Categoria</th>
                            <th scope="col">Precio</th>
                            <th scope="col">Stock</th>
                            <th scope="col"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {products.map((product) => (
                            <tr key={product._id}>
                              <th scope="row">{product._id}</th>
                              <td>{product.name}</td>
                              <td>Blancos</td>
                              <td>${product.price}</td>
                              <td>{product.stock}</td>
                              <td>
                                <div className="d-flex align-items-center justify-content-center">
                                  <button
                                    type="button"
                                    className="btn btn-warning btnAdmin d-flex justify-content-center align-items-center"
                                    onClick={() => {
                                      setProduct_id(product._id);
                                      setNombre(product.name);
                                      setPrecio(product.price);
                                      setStock(product.stock);
                                      setDescripcion(product.description);
                                      setRecomendado(product.recommended);
                                      setDestacado(product.featured);
                                      setImagenProducto(product.picture);
                                      setimagenDestacado(product.featuredPicture);
                                      settextoDestacado(product.featuredText);
                                      setCategoria(product.category);
                                      setModalEditar(true);
                                    }}
                                  >
                                    <i className="far fa-edit"></i>
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-danger btnAdmin ms-1 d-flex justify-content-center align-items-center"
                                    onClick={() => {
                                      setDeleteId(product._id);
                                      setModalBorrar(true);
                                    }}
                                  >
                                    <i className="fas fa-times"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div className="d-flex justify-content-center text-center align-items-center">
                        <Spinner animation="border" role="status"></Spinner>
                        <span className="ms-1">Loading...</span>
                      </div>
                    )}
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
        {/*  MODAL AGREGAR PRODUCTO */}
        <Modal show={modalAgregar} onHide={() => setModalAgregar(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Agregar producto</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form id="newProduct" onSubmit={postProduct}>
              <div className="mb-2">
                <label htmlFor="nombre" className="form-label">
                  Nombre
                </label>
                <input type="text" className="form-control" name="name" id="nombre" />
              </div>
              <div className="mb-3">
                <label htmlFor="exampleInputPassword1" className="form-label">
                  Categorias
                </label>
                {categories.map((category) => (
                  <Form.Check
                    type={"checkbox"}
                    key={category._id}
                    id={category._id}
                    label={category.name}
                    value={category._id}
                    name="category"
                  />
                ))}
              </div>
              <div className="mb-3">
                <label htmlFor="precio" className="form-label">
                  Precio
                </label>
                <input type="number" className="form-control" id="precio" name="price" />
              </div>
              <div className="mb-3">
                <label htmlFor="stock" className="form-label">
                  Stock
                </label>
                <input type="number" className="form-control" id="stock" name="stock" />
              </div>
              <div className="mb-3">
                <label htmlFor="descripcion" className="form-label">
                  Descripcion
                </label>
                <textarea
                  className="form-control"
                  id="descripcion"
                  rows="3"
                  name="description"
                ></textarea>
              </div>
              <div>
                <label htmlFor="picture" className="form-label">
                  Imagen del producto
                </label>
                <input
                  id="picture"
                  name="picture"
                  type="file"
                  className="form-control mb-3"
                  accept="image/*"
                />
              </div>
              <div className="mb-3 mt-5 d-flex">
                <Form.Check
                  type={"checkbox"}
                  label="Recomendado"
                  name="recommended"
                  className="pe-3"
                  onChange={() => setRecommended(!recommended)}
                />
                <Form.Check
                  type={"checkbox"}
                  label="Destacado"
                  name="featured"
                  onChange={() => setFeatured(!featured)}
                />
              </div>
              {featured && (
                <>
                  <div className="mb-3">
                    <label htmlFor="textoDestacado" className="form-label">
                      Texto destacado
                    </label>
                    <textarea
                      className="form-control"
                      name="featuredText"
                      id="textoDestacado"
                      rows="3"
                    ></textarea>
                  </div>
                  <input
                    id="featuredPicture"
                    name="featuredPicture"
                    type="file"
                    className="form-control mb-3"
                    accept="image/*"
                  />
                </>
              )}
              <div className="d-flex  justify-content-end">
                <button type="submit" className="btn btn-success">
                  Agregar
                </button>

                <button
                  type="button"
                  className="btn btn-secondary ms-2"
                  onClick={() => setModalAgregar(false)}
                >
                  Cancelar
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
        {/* MODAL BORRAR PRODUCTO */}
        <Modal show={modalBorrar} onHide={() => setModalBorrar(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>¿Estás seguro de que querés eliminar esto?</Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => {
                deleteProduct();
                setModalBorrar(false);
              }}
            >
              Borrar
            </button>

            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setModalBorrar(false)}
            >
              Cancelar
            </button>
          </Modal.Footer>
        </Modal>
        {/* MODAL EDITAR PRODUCTO */}
        <Modal show={modalEditar} onHide={() => setModalEditar(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Editar producto</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form id="editProduct" onSubmit={editProduct}>
              <div className="mb-2">
                <label htmlFor="nombre" className="form-label">
                  Nombre
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  id="nombre"
                  value={nombre}
                  onChange={(e) => {
                    setNombre(e.target.value);
                  }}
                />
                <input
                  type="hidden"
                  className="form-control"
                  name="_id"
                  id="_id"
                  value={product_id}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="exampleInputPassword1" className="form-label">
                  Categorias
                </label>
                {categories.map((category) => ({
                  ...(categoria.includes(category._id) ? (
                    <Form.Check
                      type={"checkbox"}
                      key={category._id}
                      id={category._id}
                      label={category.name}
                      defaultChecked={true}
                      value={category._id}
                      name="category"
                    />
                  ) : (
                    <Form.Check
                      type={"checkbox"}
                      key={category._id}
                      id={category._id}
                      label={category.name}
                      defaultChecked={false}
                      value={category._id}
                      name="category"
                    />
                  )),
                }))}
              </div>
              <div className="mb-3">
                <label htmlFor="precio" className="form-label">
                  Precio
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="precio"
                  name="price"
                  value={precio}
                  onChange={(e) => {
                    setPrecio(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="stock" className="form-label">
                  Stock
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="stock"
                  name="stock"
                  value={stock}
                  onChange={(e) => {
                    setStock(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="descripcion" className="form-label">
                  Descripcion
                </label>
                <textarea
                  className="form-control"
                  id="descripcion"
                  rows="3"
                  name="description"
                  value={descripcion}
                  onChange={(e) => {
                    setDescripcion(e.target.value);
                  }}
                ></textarea>
              </div>
              <div>
                <div className="d-flex flex-column">
                  <label htmlFor="textoDestacado" className="form-label">
                    Imagen del producto actual
                  </label>
                  <img className="imagen-edit-admin" src={imagenProducto} alt="imagen destacada" />
                </div>
                <label htmlFor="picture" className="form-label">
                  Cambiar imagen actual del producto
                </label>
                <input
                  id="picture"
                  name="newPicture"
                  type="file"
                  className="form-control mb-3"
                  accept="image/*"
                />
              </div>
              <div className="mb-3 mt-3 d-flex">
                <Form.Check
                  type={"checkbox"}
                  label="Recomendado"
                  name="recommended"
                  className="pe-3"
                  defaultChecked={recomendado}
                  onChange={() => setRecomendado(!recomendado)}
                />
                <Form.Check
                  type={"checkbox"}
                  label="Destacado"
                  name="featured"
                  defaultChecked={destacado}
                  onChange={() => setDestacado(!destacado)}
                />
              </div>

              {destacado && (
                <>
                  <div className="mb-3">
                    <label htmlFor="textoDestacado" className="form-label">
                      Texto destacado
                    </label>
                    <textarea
                      className="form-control"
                      name="featuredText"
                      id="textoDestacado"
                      rows="3"
                      value={textoDestacado}
                      onChange={(e) => {
                        settextoDestacado(e.target.value);
                      }}
                    ></textarea>
                  </div>
                  <div>
                    <div className="d-flex flex-column">
                      <label htmlFor="textoDestacado" className="form-label">
                        Imagen destacada actual
                      </label>
                      <img
                        className="imagen-edit-admin"
                        src={imagenDestacado}
                        alt="imagen destacada"
                      />
                      <label htmlFor="picture" className="form-label mt-3">
                        Cambiar imagen destacada actual
                      </label>
                      <input
                        id="featuredPicture"
                        name="newFeaturedPicture"
                        type="file"
                        className="form-control mb-3"
                        accept="image/*"
                      />
                    </div>
                  </div>
                </>
              )}

              <div className="d-flex  justify-content-end">
                <button type="submit" className="btn btn-success">
                  Editar
                </button>

                <button
                  type="button"
                  className="btn btn-secondary ms-2"
                  onClick={() => setModalEditar(false)}
                >
                  Cancelar
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default AdminProductos;
